.avatar {
  margin: 4px;
}
